import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxLoadingModule } from '@techmore/loading';
import { closestPolifill, GlobalModule } from '@techmore/global';
import { UploadComponent } from './upload/upload.component';
import { ImgUploadComponent } from './img-upload/img-upload.component';

export const UPLOAD_ASSETS = new InjectionToken<{ scripts: string[]; styles: string[]; }>('UPLOAD_ASSETS');
export const uploadAssetsDefaultConfig = {
  styles: ['uploader-style.bundle.css']
};

/**
 * 檔案上傳模組
 * 在引用套件的模組提供 UPLOAD_ASSETS 這個依賴項目
 * ```typescript
 * {provide: UPLOAD_ASSETS, useValue: {
 *   styles:  ['uploader-style.bundle.css']
 * }}
 * ```
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GlobalModule,
    NgxLoadingModule,
  ],
  declarations: [
    UploadComponent,
    ImgUploadComponent,
  ],
  exports: [
    UploadComponent,
    ImgUploadComponent,
  ]
})
export class UploadModule {
  static forRoot(): ModuleWithProviders<UploadModule> {
    return {
      ngModule: UploadModule,
      providers: NgxLoadingModule.forRoot({}).providers
    };
  }

  constructor() {
    closestPolifill();
  }
}
